import { NgModule } from '@angular/core';

import { VbUiSplitLinesInputDirective } from './VbUiSplitLinesInput.Directive';

@NgModule({
	declarations: [VbUiSplitLinesInputDirective],
	exports: [VbUiSplitLinesInputDirective]
})
export class VbUiSplitLinesInputModule {}
